// extracted by mini-css-extract-plugin
export default {"form":"Souscripteur_form__5sDQO","titre":"Souscripteur_titre__RyM8G","souscripteurTitle":"Souscripteur_souscripteurTitle__CBYUk","inputTitle":"Souscripteur_inputTitle__Uw0hw"};